import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { SmsModel } from './sms.model';
import { IItemsListDataFetchResult } from '@fi-shared/fi-items-list/fi-items-list';
import { ISMSMessageParameter } from '@fi-app/sms/sms';
import { ISmsCostsData } from './sms-costs/sms-costs';

@Injectable()
export class SmsService {
    constructor(private fiBackend: FiBackendService) {}

    getSMSModel() {
        return new SmsModel();
    }

    getSMSList(params) {
        return this.fiBackend.fetchObjectsPost<SmsModel>('SMS/SMS/GetUserSMSMessages', SmsModel, params);
    }

    getSMS(Id) {
        return this.fiBackend.fetchObject('SMS/SMS/GetUserSMSMessage/' + Id, SmsModel);
    }

    sendSMS(sms) {
        return this.fiBackend.fetchDataPost('SMS/SMS/SendSMSMessage', sms);
    }

    getSMSCosts(year, month) {
        return this.fiBackend.fetchData<ISmsCostsData>(`SMS/SMS/GetSMSCosts/${year}/${month}`);
    }

    getSMSListData(parameter: ISMSMessageParameter) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<any>>(
            'SMS/SMS/GetSMSMessagesListData',
            parameter,
        );
    }
}
